import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { LambdaCapacityProvider } from '@localstack/types';
import { getSchema } from '@localstack/services';

import { MagicTable } from '../../magic/MagicTable';

export type LambdaCapacityProvidersTableProps = {
  loading?: boolean;
  selectable?: boolean;
  capacityProviders: LambdaCapacityProvider[];
  onSelect?: (names: string[]) => void;
  onView?: (name: string) => void;
};

export const LambdaCapacityProvidersTable = ({
  loading,
  selectable = true,
  capacityProviders,
  onSelect,
  onView,
}: LambdaCapacityProvidersTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('Lambda')}
    entry="CapacityProvidersList"
    idAttribute="CapacityProviderArn"
    order={['CapacityProviderArn']}
    rows={capacityProviders}
    selectable={selectable}
    onSelect={onSelect}
    loading={loading}
    externalFields={{
      CapacityProviderArn: (row) => (
        <Link onClick={() => onView && onView(row.CapacityProviderArn?.split(':').pop() as string)} underline="hover">
          {row.CapacityProviderArn}
        </Link>
      ),
    }}
  />
);
